
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-conditions",
      function () {
        return require("private-next-pages/terms-conditions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-conditions"])
      });
    }
  